// extracted by mini-css-extract-plugin
export default {"tableWrapper":"tableWrapper---KnIQx","pageSizeRow":"pageSizeRow---n7Z6L","pageSizeLabel":"pageSizeLabel---SV38Q","pageSizeSelect":"pageSizeSelect---KHTcs"};